import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBlocks: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"blocks, integration, apps"} maskId="square-filled-radius-0-stroke-1-IconBlocks"><path fillRule="evenodd" clipRule="evenodd" d="M11 13H18V21H3V6H11V13ZM11 20H17V14H11V20ZM4 13H10V7H4V13Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M21 11H13V3H21V11Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconBlocks;
